<template lang="pug">
  .curations-wrapper(v-if="curations.length > 0")
    .curations-header
      span.curations-header-tag
        | {{ __('#RYOUROGUE') }}
      span.curations-header-description
        | {{__(addCurationText)}}
      rogue-link.curations-header-link(to="/theindex/ryourogue")
        span {{ __('View Full Gallery') }}
        Icon.icon-size-xxs(name='arrow-right' fill='blue')
    .curations
      Carousel(:bottom-padding="24" :controls="true" prevLabel="Previous #RYOUROGUE posts" nextLabel="Next #RYOUROGUE posts" label="#RYOUROGUE posts")
        button.a11y.curation-slide(
          type="button"
          v-for="(curation, i) in curations"
          :aria-label="curationLabel(curation)"
          :key="curation.id || i"
          @click="toggleCurationModal(i)"
        )
          StaticImage.curation-image.image(:src="curation.image" :alt="curationLabel(curation)" :width="340")
    CarouselModal(
      v-if="showRoguebox"
      :value="rogueboxCurrent"
      @close="showRoguebox = false"
      @input="trackView($event)"
    )
      Curation.roguebox-curation-slide(
        v-for="curation in curations"
        @click.stop=""
        @close="showRoguebox = false"
        :key="curation.id"
        :author="curation.author"
        :date="curation.date"
        :text="curation.text"
        :image="curation.image"
        :source="curation.source"
        :permalink="curation.permalink"
        :products="curation.products"
      )
</template>
<script>
import { useHttpStore } from '@/js/stores/httpStore'
import Curation from '@/js/components/curation.vue'

const addCurationText = 'Tag your photos on Instagram and Twitter with #RYOUROGUE for a chance to be featured in our gallery'

export default {
  name       : 'Curations',
  components : { Curation },
  props      : {
    product: {
      type    : Object,
      default : () => ({}),
    },
  },
  setup() {
    const httpStore = useHttpStore()

    return { httpStore }
  },
  data: () => ({
    showRoguebox     : false,
    rogueboxCurrent  : null,
    overlayCurations : [],
    addCurationText,
    curations        : [{}, {}, {}],
    sliderOpts       : {
      perPage: {
        0   : 2,
        960 : 4,
      },
      multipleDrag: true,
    },
  }),
  computed: {
    cache() {
      return this.httpStore.cache
    },
  },

  watch: {
    'product.sku': {
      handler() {
        this.load()
      },
    },
  },

  mounted() {
    this.load()
  },

  methods: {
    async load() {
      if (this.product?.sku) {
        try {
          let data = await this.$rogue.api.fetch({
            url   : `/svc_content/curations/list?sku=${this.product.sku}&limit=10`,
            cache : { key: `curations-${this.product.sku}`, seconds: 60 * 60 * 6 }, // six hours
          })

          if (!Array.isArray(data)) {
            data = data.items
          }

          this.curations = data.filter((f) => f.media?.largeSquare?.link || f.media?.poster?.largeSquare?.link).map((item) => ({
            id        : item.id,
            image     : item?.media?.largeSquare?.link || item?.media?.poster?.largeSquare?.link,
            author    : item.source.user,
            date      : new Date(item.source.postedTimestamp * 1000).toLocaleDateString(),
            text      : item.source.caption,
            source    : item.source.type,
            permalink : item.source.link,
            type      : item.type,
          }))
        } catch (e) {
          this.$rogue.log.error('Error loading curations from Curalate', e)
          this.curations = []
        }
      }
    },

    // Placeholder slides (before the list loads) and some posts have no author
    curationLabel(curation) {
      return curation.author
        ? this.__('Post by {author}', { author: curation.author })
        : this.__('Customer post')
    },

    trackView(index) {
      const curation = this.curations[index]
      this.$rogue.track.track({ type: 'viewCuration', product: this.product, curation })
    },

    toggleCurationModal(index) {
      if (index !== undefined) {
        this.showRoguebox = true
        this.rogueboxCurrent = index
        this.trackView(index)
      } else {
        this.showRoguebox = false
      }
    },
  },
}

</script>
<style lang="scss" scoped>
.curations-header {
  flex-flow: nowrap;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: $space-s 0;
  margin-bottom: $space-s;
  border-bottom: $border-width-thin solid $color-gray-light;
  line-height: 1;

  &-tag {
    font-size: $size-xxl;
    font-weight: $weight-bold;
  }

  &-description {
    font-size: $size-xs;
    text-align: center;
  }

  &-link {
    display: flex;
    align-items: center;
    color: $color-blue;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }

    .icon {
      margin-left: $space-xxxs;
    }
  }
}

@include not-desktop() {
  .curations-header {
    flex-direction: column;
  }
  .curations-header-description {
    max-width: 100%;
    margin: $space-s;
  }
}

.curations {
  margin: 0 auto;
}

@include all-desktop() {
  .curations {
    width: 1052px;
  }
}

.curations-header-link {
  text-decoration: none;
}

.curation-slide {
  display: block;
  position: relative;
  cursor: pointer;
  margin-right: $space-s;

  &:last-child {
    margin-right: 0;
  }

  .image {
    background-size: cover;
    width: 340px;
    height: 340px;
  }
}

</style>
